export const getTriggerOptions = (options, t, availableStatuses) => {
  return options
    .filter(option => availableStatuses?.includes(option.value))
    .map(option => {
      return {
        ...option,
        label: t(option.label),
      }
    })
}

export const getTriggerModeOptions = (options, t) => {
  return options.map(option => {
    return {
      ...option,
      label: t(option.label),
    }
  })
}
